module.exports = __webpack_public_path__ + "static/media/drink-category.fa68aaa5.png";